/* Prop Types */
interface DragonflyIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const DragonflyIcon = ({ className, ...props }: DragonflyIconProps) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M10.1182 9.87302C10.1182 9.87302 10.604 9.54371 10.7511 9.46449C10.884 9.39303 11.0027 9.31847 11.104 9.28274C12.5535 8.76703 13.3874 8.80431 13.9381 8.82761C14.8385 8.80742 15.5031 8.81208 16.3766 8.24044C16.6978 8.03074 16.9367 7.72317 17.0966 7.39231C17.6947 6.15739 17.4748 4.63199 16.4415 3.60833C15.4066 2.58311 13.8637 2.3672 12.6152 2.96058C12.2829 3.11902 11.9917 3.36445 11.7607 3.67202C11.1436 4.49685 11.1436 5.14926 11.1673 6.08438C11.1436 6.58612 11.2322 7.4591 10.71 8.89285C10.6736 8.99382 10.5992 9.10721 10.5264 9.2408C10.4473 9.38682 10.1182 9.87302 10.1182 9.87302Z"
        fill="#F2318A"
      />
      <path
        d="M9.88223 10.1287C9.88223 10.1287 9.39643 10.458 9.24927 10.5372C9.11635 10.6086 8.99767 10.6832 8.89639 10.7189C7.44691 11.2347 6.61298 11.1974 6.06231 11.1741C5.16192 11.1943 4.49731 11.1896 3.62382 11.7612C3.3026 11.9709 3.06365 12.2785 2.90383 12.6078C2.30568 13.8427 2.52405 15.3681 3.55894 16.3918C4.59384 17.417 6.13668 17.6329 7.3852 17.0395C7.7175 16.8811 8.00867 16.6357 8.2397 16.3281C8.85683 15.5033 8.85683 14.8509 8.8331 13.9157C8.85683 13.414 8.76822 12.541 9.29041 11.1073C9.32681 11.0063 9.40118 10.8929 9.47397 10.7593C9.55467 10.6133 9.88223 10.1287 9.88223 10.1287Z"
        fill="#F2318A"
      />
      <path
        d="M11.1491 16.4212C12.6017 17.8596 14.9579 17.8596 16.4106 16.4212C17.8632 14.9827 17.8632 12.6527 16.4106 11.2143C14.9579 9.7759 12.6017 9.7759 11.1491 11.2143C9.69641 12.6527 9.69641 14.9843 11.1491 16.4212Z"
        fill="#19D3C8"
      />
      <path
        d="M3.59067 8.78566C5.04332 10.2241 7.39952 10.2241 8.85217 8.78566C10.3048 7.34725 10.3048 5.01722 8.85217 3.57881C7.39952 2.1404 5.04332 2.1404 3.59067 3.57881C2.13644 5.01722 2.13644 7.34725 3.59067 8.78566Z"
        fill="#19D3C8"
      />
    </svg>
  );
};
